import { BiteLogLrsTableTrackerEvent } from './bite_log_lrs_table_tracker_event.js';

export function name(event: BiteLogLrsTableTrackerEvent): string {
  switch (event) {
    case BiteLogLrsTableTrackerEvent.GetIpAddressSuccess:
      return 'get-ip-address-success';
    case BiteLogLrsTableTrackerEvent.GetIpAddressError:
      return 'get-ip-address-error';
    case BiteLogLrsTableTrackerEvent.GetIpAddressFromStorageCache:
      return 'get-ip-address-from-storage-cache';
    case BiteLogLrsTableTrackerEvent.ValidateIpAddressSuccess:
      return 'validate-ip-address-success';
    case BiteLogLrsTableTrackerEvent.ValidateIpAddressError:
      return 'validate-ip-address-error';
    case BiteLogLrsTableTrackerEvent.GetAccessTokenSuccess:
      return 'get-access-token-success';
    case BiteLogLrsTableTrackerEvent.GetAccessTokenWaiting:
      return 'get-access-token-waiting';
    case BiteLogLrsTableTrackerEvent.GetAccessTokenError:
      return 'get-access-token-error';
    case BiteLogLrsTableTrackerEvent.GetAccessTokenSaveWarning:
      return 'get-access-token-save-warning';
    case BiteLogLrsTableTrackerEvent.GetAccessTokenSaveSuccess:
      return 'get-access-token-save-success';
    case BiteLogLrsTableTrackerEvent.ValidateAccessTokenSuccess:
      return 'validate-access-token-success';
    case BiteLogLrsTableTrackerEvent.ValidateAccessTokenError:
      return 'validate-access-token-error';
    case BiteLogLrsTableTrackerEvent.ActivateOrderSuccess:
      return 'activate-order-success';
    case BiteLogLrsTableTrackerEvent.ActivateOrderError:
      return 'activate-order-error';
    case BiteLogLrsTableTrackerEvent.ActivateOrderSkipped:
      return 'activate-order-skipped';
    case BiteLogLrsTableTrackerEvent.LrsConnected:
      return 'lrs-connected';
    case BiteLogLrsTableTrackerEvent.LrsDisconnected:
      return 'lrs-disconnected';
    case BiteLogLrsTableTrackerEvent.LrsFailed:
      return 'lrs-failed';
    case BiteLogLrsTableTrackerEvent.LrsStateChanged:
      return 'lrs-state-changed';
  }
}
